const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: [ "/staking"],
    exact: true,
    component: "Staking",
  },
  {
    path: [ "/privacy"],
    exact: true,
    component: "Privacy",
  },
  {
    path: [ "/cookies"],
    exact: true,
    component: "Cookies",
  },
  {
    path: [ "/terms"],
    exact: true,
    component: "Terms",
  },
];

export default routes;
